import React from 'react';
import { string } from 'prop-types';
import { SearchIconWrapper, NotFoundTitle, SearchIcon, NotFound } from './product-list.styles';

const ProductListNotFound = ({
  message,
  messageSecondary
}) => /*#__PURE__*/React.createElement(NotFound, {
  "data-testid": "product-list-empty"
}, /*#__PURE__*/React.createElement(SearchIconWrapper, null, /*#__PURE__*/React.createElement(SearchIcon, null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NotFoundTitle, null, message), messageSecondary || ''));

process.env.NODE_ENV !== "production" ? ProductListNotFound.propTypes = {
  messageSecondary: string,
  message: string
} : void 0;
ProductListNotFound.defaultProps = {
  messageSecondary: '',
  message: ''
};
export default ProductListNotFound;